import { getRgObjectsOfType as i, RG_TYPE as g } from "@project-rouge/rg-core";
import { getLevelGlazedFacadeArea as c } from "./index21.js";
import { getLevelGrossFacadeArea as d } from "./index22.js";
const l = (o, e) => {
  const a = i(o, g.Building);
  let r = 0;
  for (const t of a)
    r += d(t, e) - c(t, e);
  return r;
};
export {
  l as getLevelNetFacadeArea
};
//# sourceMappingURL=index24.js.map
